<template>
    <el-row :gutter="5">
        <el-col :span="5"></el-col>
        <el-col :span="12"><h2 class="heading">Contract Calendar</h2></el-col>
        <el-col :span="7" style="padding-right:20px; padding-top:20px; text-align:center;">
            <el-button style="margin-left:20px;" @click="$router.push('/contract/allContracts')" v-if="global.hasRight('contract', 'admin')">
                <el-icon><Search/></el-icon> &nbsp; All Contracts</el-button>
        </el-col>
    </el-row>


    <div class="form">
        <table class="calendar">
            <tr>
                <th></th>
                <th v-for="month in months" :key="month">{{month}}</th>
            </tr>
            <tr>
                <th>Renewal<br/>Contract</th>
                <td v-for="(items, index) in renewList" :key="index" :class="items.length>0?'renew':''">
                    <div v-for="(contract, j) in items" :key="j">
                        <a :href="'/contract/viewContract?code='+contract.idMD5">{{ contract.vendorName }}</a>
                    </div>
                </td>
            </tr>
            <tr>
                <th>Cancel<br/>Contract</th>
                <td v-for="(items, i) in cancelList" :key="i" :class="items.length>0?'cancel':''">
                    <div v-for="(contract, j) in items" :key="j">
                        <a :href="'/contract/viewContract?code='+contract.idMD5">{{ contract.vendorName }}</a>
                    </div>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>

import AXIOS from '@/common/axios.js'
import global from '@/common/global.js'
import { Search } from '@element-plus/icons-vue'

export default {
    data() {
        return {
            allETFs : ["2803", "3173", "3151", "3453", "3181", "2810",
                        "2804", "3077", "2817", "3001", "3411", "3478"], 
            allTerms: ["3 Months", "6 Months", "1 Year", "2 Years", "3 Years", "4 Years", "5 Years", "7 Years", "10 Years", "15 Years"],
            allCurrencies: ["HKD", "USD", "CNY", "EUR", "GBP", "JPY"],
            allFrequencies: ["Monthly", "Quarterly", "Annually"],
            etf : '',
            months: [],
            renewList: [],
            cancelList: [],
            errMsg: '',
            global,
        }
    },
    components: {
        Search
    },
    async mounted() {
        this.global.index = "contract";
        let result = await AXIOS("/contract/getContractCalendar");
        if (result.success) {
            this.months = result.data.months;
            this.renewList = result.data.renewList;
            console.log(this.renewList);
            console.log(this.renewList.length);
            this.cancelList = result.data.cancelList;
        } else {
            this.errMsg = result.errMsg;
        }
    }
}
</script>

<style scoped>
    .errMsg {
        padding-left:10px;
    }
    .calendar {width:100%; border-collapse: collapse;}
    .calendar th {text-align:center; color:#595959; border:1px solid #ddd; height:50px; width:7.6%; font-size:14px; background:#F8F8F8;}
    .calendar td {height:120px; text-align: center; border:1px solid #ddd; font-size:13px; color:#666;}
    .renew {background:#EFF; }
    .cancel {background:#FFE;}
    .calendar a {text-decoration: none; color:#269;}
    .calendar a:hover {text-decoration: underline; color:#01baaf;}
</style>